import("../src/javascripts/attachments-redesign");
import("../src/javascripts/navigation");
import("../src/javascripts/easy-toggle");
import('../src/javascripts/slider_splide');
